import {ReactNode, useEffect} from 'react';
import {requestContext} from '../../../../../../common/requestContext';
import useTypedDispatch from '../../../../../../common/useTypedDispatch';
import {Loading} from '../../../../../../design-system/atoms/Loading/Loading';
import {viewerHistory} from '../constant';
import {useFetchViewerInfo} from '../hook/useFetchViewerInfo';
import {
  clearFromPrevProduct,
  setFromPrevProduct,
} from '../state/viewerInfoSlice';

export interface ViewerInfoFetcherHeadlessProps {
  seriesId: number;
  productId: number;
  children: ReactNode;
}

export function ViewerInfoFetcherHeadless({
  seriesId,
  productId,
  children,
}: ViewerInfoFetcherHeadlessProps) {
  const dispatch = useTypedDispatch();
  const {isLoading, data} = useFetchViewerInfo({
    seriesId,
    productId,
  });

  useEffect(() => {
    if (!data) {
      return;
    }

    const prevProductId =
      viewerHistory.length > 1
        ? viewerHistory[viewerHistory.length - 2]
        : undefined;
    dispatch(
      setFromPrevProduct(
        data.prevItem?.productId
          ? data.prevItem?.productId === prevProductId
          : false
      )
    );
  }, [data, dispatch, productId]);

  useEffect(() => {
    return () => {
      dispatch(clearFromPrevProduct());
    };
  }, [productId, dispatch]);

  if (!children) {
    return null;
  }

  return (
    <>
      {isLoading && !requestContext.requestInfo.display.isWebView && (
        <div className="flex-center-full">
          <Loading />
        </div>
      )}
      {!isLoading && data && <>{children}</>}
    </>
  );
}
